import { styled } from 'stitches.config'

export const UnorderedList = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',

  '& li::before': {
    content: '\\2023',
    color: '$accent-black',
    marginLeft: '-16px',
    marginRight: '8px',
  },
})

export const OrderedList = styled('ol', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',

  '& li': {
    listStyle: 'number',
  },
})
